export const deviceSize ={
	mmobile:375,
	mobile: 480,
	tablet: 943,
	slaptop:1200,
	laptop: 1442,
	monitor:1920,
	desktop: 2024,
	M4k:2560,
};
  